import React from "react";
import {
  Box,
  Container,
  Typography,
  Chip,
} from "@mui/material";
import {
  FiberManualRecord,
} from "@mui/icons-material";
import { styled, keyframes } from "@mui/material/styles";

const SUPPORTERS = [
  { id: 1, name: "Supporter 1", logo: "/supporters/Wadhwani logo.png" },
  { id: 2, name: "Supporter 2", logo: "/supporters/DST-NIDHI.png" },
  { id: 3, name: "Supporter 3", logo: "/supporters/IIITDIC Logo.png" },
  { id: 4, name: "Supporter 4", logo: "/supporters/image-6.png" },
  { id: 5, name: "Supporter 5", logo: "/supporters/Digital impact sq logo.webp" },
  { id: 6, name: "Supporter 6", logo: "/supporters/ksum.png" },
  { id: 8, name: "Supporter 8", logo: "/supporters/TIH-logo.png" },
  { id: 9, name: "Supporter 9", logo: "/supporters/maker.png" },
  { id: 12, name: "Supporter 12", logo: "/supporters/Selco foundation .png" },
  { id: 10, name: "Supporter 10", logo: "/supporters/SRM incubation and innovation .png" },
  { id: 11, name: "Supporter 11", logo: "/supporters/ministry.png" },
  { id: 12, name: "Supporter 12", logo: "/supporters/Startup-India.png" },
];

// Animations
const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
`;

// Styled Components
const BackgroundBox = styled(Box)({
  position: "relative",
  minHeight: "auto",
  background: "linear-gradient(180deg, #000000 0%, #0a0a0a 50%, #000000 100%)",
  overflow: "hidden",
  paddingTop: "60px",
  paddingBottom: "60px",
});

const GradientOrb = styled(Box)(({ top, left, bottom, right, color }) => ({
  position: "absolute",
  width: 500,
  height: 500,
  borderRadius: "50%",
  background: color,
  filter: "blur(100px)",
  pointerEvents: "none",
  top,
  left,
  bottom,
  right,
}));

const GridPattern = styled(Box)({
  position: "absolute",
  inset: 0,
  opacity: 0.05,
  backgroundImage: `linear-gradient(rgba(148, 163, 184, 0.1) 1px, transparent 1px),
                     linear-gradient(90deg, rgba(148, 163, 184, 0.1) 1px, transparent 1px)`,
  backgroundSize: "50px 50px",
  pointerEvents: "none",
});

const SupporterItem = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  padding: "18px",
  transition: "all 0.3s ease",
  opacity: 1,
  flexShrink: 0,
  "&:hover": {
    "& .supporter-logo": {
      transform: "scale(1.1)",
    },
  },
});

const LogoImage = styled("img")({
  width: 80,
  height: 80,
  objectFit: "contain",
  transition: "all 0.3s ease",
  filter: "none",
  opacity: 1,
  "&:hover": {
    transform: "scale(1.05)",
  },
});

const HomepageSupporters = () => {
  return (
    <BackgroundBox>
      {/* Background Elements */}
      <GradientOrb top="50%" left={-256} color="rgba(193, 227, 40, 0.08)" />
      <GradientOrb bottom="50%" right={-256} color="rgba(193, 227, 40, 0.08)" />
      <GridPattern />

      <Container maxWidth="xl" sx={{ position: "relative" }}>
        {/* Section Header */}
        <Box textAlign="center" mb={4}>
          {/* Badge */}
          <Chip
            icon={
              <FiberManualRecord
                sx={{
                  fontSize: 8,
                  animation: `${pulse} 2s ease-in-out infinite`,
                }}
              />
            }
            label="BACKED BY INDUSTRY LEADERS"
            sx={{
              background: "rgba(0, 0, 0, 0.5)",
              backdropFilter: "blur(8px)",
              border: "1px solid rgba(193, 227, 40, 0.3)",
              color: "#c1e328",
              fontWeight: 700,
              letterSpacing: 3.2,
              fontSize: "0.555rem",
              mb: 2,
            }}
          />

          {/* Title */}
          <Typography
            variant="h3"
            sx={{
              fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },
              fontWeight: 700,
              color: "#fff",
              letterSpacing: -0.5,
              mb: 1,
            }}
          >
            Our{" "}
            <Box
              component="span"
              sx={{
                background:
                  "linear-gradient(135deg, #c1e328 0%, #b5d028 50%, #a8c728 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Supporters
            </Box>
          </Typography>
        </Box>

        {/* Supporters Grid */}
        <Box sx={{ py: 2 }}>
          {/* First Row - 9 items */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: { xs: 1, md: 2 },
              mb: 2,
              flexWrap: "wrap",
            }}
          >
            {SUPPORTERS.slice(0, 9).map((supporter) => (
              <SupporterItem key={supporter.id}>
                <LogoImage 
                  className="supporter-logo" 
                  src={supporter.logo} 
                  alt={supporter.name}
                />
              </SupporterItem>
            ))}
          </Box>

          {/* Second Row - 3 items */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: { xs: 1, md: 2 },
              flexWrap: "wrap",
            }}
          >
            {SUPPORTERS.slice(9, 12).map((supporter) => (
              <SupporterItem key={supporter.id}>
                <LogoImage 
                  className="supporter-logo" 
                  src={supporter.logo} 
                  alt={supporter.name}
                />
              </SupporterItem>
            ))}
          </Box>
        </Box>
      </Container>
    </BackgroundBox>
  );
};

export default HomepageSupporters;

